import ImpersonateCard from './ImpersonateCard';

export default ImpersonateCard;
